import Vue from 'vue'
export default {
  namespaced: true,
  state: {
    drawerGoFinance: false,
  },
  mutations: {
    setDrawerGoFinance(state, data) {
      state.drawerGoFinance = data
    }
  },
  actions: {

  },
  getters: {

  },
}
